import React from 'react';

const CustomBuild: React.FC = () => {
  return (
    <section className="py-8 md:py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="order-2 lg:order-1">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Montage sur mesure
            </h2>
            
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              Des cadres, un groupes, des roues, des composants ergonomiques...
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-8">
              Il est plus qu'important de réaliser le montage de votre futur vélo ! Avant avec la bonne géométrie, avant avec la bonne cinématique, avant les bons composants permettant la performance et surtout avant tout, nous réalisons le montage sur votre cadre selon votre étude posturale.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button className="bg-black text-white px-8 py-3 rounded-lg hover:bg-gray-800 transition-colors duration-300 font-medium">
                Nos marques
              </button>
              <button className="border-2 border-black text-black px-8 py-3 rounded-lg hover:bg-black hover:text-white transition-colors duration-300 font-medium">
                Configurateur
              </button>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="order-1 lg:order-2">
            <div className="relative rounded-lg overflow-hidden shadow-2xl aspect-[4/3] bg-gradient-to-br from-gray-800 to-gray-900">
              <img
                src="/atelier-podium.png"
                alt="Montage sur mesure"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomBuild;

